import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Menu, X, Ticket } from "lucide-react";
import AudioController from "./AudioController";

const Navbar = ({ user, logout, onSignUpClick }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar-fixed fixed top-0 left-0 right-0 bg-background/90 backdrop-blur-xl border-b border-border" style={{ zIndex: 9999 }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-logo">
            <div className="w-8 h-8 bg-primary flex items-center justify-center">
              <Ticket className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground group-hover:text-primary transition-colors">
              XTRIP
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link 
              to="/events" 
              className="text-sm font-medium uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors"
              data-testid="nav-events"
            >
              Experiences
            </Link>
            <AudioController />
          </div>

          {/* Sign Up Button - Always Visible */}
          <div className="hidden md:flex items-center gap-4">
            <Button 
              onClick={onSignUpClick}
              className="bg-primary text-primary-foreground hover:bg-primary/90 btn-glow uppercase tracking-wider text-sm font-semibold"
              data-testid="nav-signup-btn"
            >
              Sign Up
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-3">
            <AudioController />
            <button
              className="text-foreground"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-4">
              <Link 
                to="/events" 
                className="text-sm font-medium uppercase tracking-wider text-muted-foreground hover:text-primary"
                onClick={() => setMobileMenuOpen(false)}
              >
                Experiences
              </Link>
              <Button 
                onClick={() => { onSignUpClick(); setMobileMenuOpen(false); }}
                className="bg-primary text-primary-foreground w-full uppercase tracking-wider"
              >
                Sign Up
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
